import { render, staticRenderFns } from "./PersonalityEstimation.vue?vue&type=template&id=23278211&scoped=true&"
import script from "./PersonalityEstimation.vue?vue&type=script&lang=js&"
export * from "./PersonalityEstimation.vue?vue&type=script&lang=js&"
import style0 from "./PersonalityEstimation.vue?vue&type=style&index=0&id=23278211&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23278211",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VContainer,VRow,VTextarea})
